<!-- Copyright 2025, Common Good Learning Tools LLC -->
<template>
	<v-data-table
		:items="items"
		:headers="tab.headers"
		:options.sync="options"
		:server-items-length="total"
		:footer-props="footerProps"
		:search="tab.search.term"
		class="k-table"
		height="calc(100% - 125px)"
		width="100%"
		fixed-header
		light
	>
		<template v-slot:item="{ item }">
			<AssetManagerTableRow
				:row="item"
				:headers="tab.headers"
				:type="tab.key.includes('payment') ? 'log' : 'asset'"
				@showStatus="$emit('showStatus', item)"
				@pay="pay"
			/>
		</template>
	</v-data-table>
</template>

<script>
import { mapState } from 'vuex'
import AssetManagerTableRow from './AssetManagerTableRow.vue'

export default {
	name: 'AssetManagerTable',

	components: {AssetManagerTableRow},

	props: {
		tab: {type: Object, required: true},
		statuses: {type: Array, required: true}
	},

	data() {
		return {
			init: false,
			items: [],
			total: 0,
			options: {
				groupBy: [],
				groupDesc: [],
				itemsPerPage: 100,
				multiSort: false,
				mustSort: false,
				page: 1,
				sortBy: [],
				sortDesc: [false]
			},
			footerProps: {
				'items-per-page-options': [100, 50, 25, 10]
			},
		}
	},

	computed: {
		...mapState(['user_info', 'site_config']),
	},

	watch: {
		options: {
			handler() {
				if (this.init) {
					this.load()
				}
			}, 
			deep: true,
		}
	},

	emits: ['pay'],

	mounted() {
		this.load()
	},

	methods: {
		load() {
			if (this.tab.key.includes('payment')) {
				this.load_log()
			} else {
				this.load_assets()
			}
		},

		load_assets() {
			let { page, itemsPerPage } = this.options
			let limit = itemsPerPage
			let offset = (page - 1) * itemsPerPage

			let payload = {
				user_id: this.user_info.user_id,
				type: this.tab.key,
				limit,
				offset
			}

			U.ajax('get_unpublished_assets', payload, result => {
				this.init = true
				if (!result.status == 'ok') {
					console.error('something went wrong: ', result)
				} else {
					this.items = result.assets.map(x => {
						let status = {key: null, text: 'Not Submitted for Publication'}
						if(x.publish_status) {
							status = this.statuses.filter(status => status.key === x.publish_status)[0] 
						}
						x.publish_status = status

						return x
					})

					this.total = this.items.length
				}
			})
		},

		load_log() {
			let payload = {
				user_id: this.user_info.user_id,
				type: this.tab.key,
			}

			U.ajax('get_asset_log', payload, result => {
				this.init = true
				if (!result.status == 'ok') {
					console.error('something went wrong: ', result)
				} else {
					this.items = result.log
					this.total = this.items.length
				}
			})
		},

		pay(log_data) {
			this.$confirm({
			    title: 'Record Payment',
			    text:  'To: ' + log_data.user_name + '&nbsp;&nbsp;&nbsp;For: ' + log_data.asset_title,
			    acceptText: 'Record Payment',
				acceptColor: 'green',
			}).then(() => {
				this.$store.dispatch('save_asset_log', log_data)
					.then(() => {
						this.load()
						this.$emit('pay')
					})
			}).catch(n=>{console.error(n)});
		}
	},
}
</script>

<style lang="scss" scoped>
.k-table {
	height: 100%;
	width: 100%;
}
</style>